import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, } from 'react-router-dom';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { InputBox } from "../CommonComponents/InputBox";

const UpdatePacketBooking = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [formData, setFormData] = useState({ awbNo: "" });

    const updateAwbFormfunction = async (value) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/CheckAwbNo', {
            AwbNo: value.trim(), pageType: 'UPD', "Type": "PacketBooking"
        })
        await dispatch(setSubLoading(false))
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED' || data.Status === 'UNAUTHORIZED') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        else if (data.Status === 'SUCCESS') {
            await navigate(`/PacketBooking?AwbNo=${value.trim()}&PageType=UPD`);
        }
    };

    useEffect(() => {
        document.title = 'Update Packet Booking';
        inputrefs.current['txtAwbNumber'].focus()
    }, [])

    return (
        <div className='main-card card border-0'>
            <div className='card-header mb-1'>
                <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Update Packet Booking')}</span>
            </div>
            <div className='card-body'>
                <div className='row'>
                    <InputBox
                        label='Awb Number'
                        inputrefs={inputrefs}
                        id='txtAwbNumber'
                        value={formData.awbNo}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') { inputrefs.current['txtbtn'].focus() };
                        }}
                        onChange={(e) => {
                            //let { value } = e.target
                            //const aphanum = value.replace(/[^a-zA-Z0-9]/g, '')
                            setFormData({ ...formData, awbNo: e.target.value })
                        }}
                        maxLength='25'
                        required={true}
                    />
                    <div className='col-md-2' style={{ marginTop: "16px" }} >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={() => updateAwbFormfunction(formData.awbNo)}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                            </span> {FindTranslatedKey('Validate Awb')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default UpdatePacketBooking;